// src/Components/ThankYou.jsx
import React from 'react';

function PaymentConfirmation() {
  return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <h1>Thank You for Your Purchase!</h1>
      <p>We've sent you a confirmation email and will be in touch soon.</p>
    </div>
  );
}

export default PaymentConfirmation;
